import script from "./recruiterDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./recruiterDashboard.vue?vue&type=script&setup=true&lang=js"

import "./recruiterDashboard.vue?vue&type=style&index=0&id=84836a84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84836a84"]])

export default __exports__